import React from 'react';
import './spinnerloader.css';

const SpinnerLoader = ({withoutMargin}) => <div className={`spinner-loader${withoutMargin ? ' without-margin' : ''}`} />;

export default SpinnerLoader;
